import React from 'react';
import { motion } from 'framer-motion';

const ContactV3 = () => {
  return (
    <section className="w-full rounded-2xl bg-white border border-gray-200">
      <div className="max-w-6xl mx-auto px-6 py-24">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          viewport={{ once: true }}
          className="rounded-xl bg-blue-600 text-white p-8 md:p-10 shadow-md hover:shadow-lg transition-all duration-300"
        >
          <h2 className="text-4xl font-bold tracking-tight mb-4">Contact</h2>
          <p className="text-lg text-blue-100 mb-6">Open for senior backend roles, consulting, and SaaS engineering projects.</p>
          <div className="flex flex-col sm:flex-row gap-4">
            <a
              href="mailto:shalender8928@yahoo.com"
              className="inline-flex justify-center rounded-lg bg-white text-blue-700 px-6 py-3 font-semibold hover:-translate-y-2 transition-all duration-300"
            >
              Email Me
            </a>
            <a
              href="https://www.linkedin.com/in/shalender8928/"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex justify-center rounded-lg border border-white px-6 py-3 font-semibold hover:-translate-y-2 transition-all duration-300"
            >
              LinkedIn
            </a>
          </div>
        </motion.div>
      </div>
    </section>
  );
};

export default ContactV3;
